import Vue from 'vue';
import VueRouter from 'vue-router';
// import Main from '@/components/Main';
import { store } from '@/store';
import { mixin } from '@/utils/mixins';

// guard проверка на повторный переход в тот же роут
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// import { errorHandler } from '../utils/errorHandler'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  mixins: [mixin],
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        module: 'Dashboard'
      },
      component: () => import('Parts/HomePage/HomePage')
    },
    {
      path: '/widgetEdit',
      name: 'widgetEdit',
      meta: { auth: true, rightPanel: false, layout: 'main' },
      component: () => import('Parts/HomePage/WidgetEdit')
    },
    {
      path: '/storybook',
      name: 'StoryBook',
      meta: { auth: true, rightPanel: false, layout: 'main' },
      component: () => import('@/components/StoryBook')
    },
    {
      path: '/candidates/edit',
      name: 'candidatesEdit',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateEditWrapper')
    },
    {
      path: '/candidates/edit/:id',
      name: 'candidatesEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateEditWrapper')
    },
    {
      path: '/duplicates',
      name: 'HRPAC_CANDIDATES_DUPLICATES',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Dublicates/List/DublicatesWrapper')
    },
    {
      path: '/candidates',
      name: 'HRPAC_CANDIDATES',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateWrapper'),
      children: [
        {
          path: '/candidates/:id',
          name: 'candidateId',
          meta: {
            auth: true,
            rightPanel: true,
            layout: 'main',
            parent: '/candidates',
            module: 'HRPAC_CANDIDATES'
          }
        },
        {
          path: '/candidates/:id/comments/:commentId',
          name: 'commentId',
          meta: {
            auth: true,
            rightPanel: true,
            trigger: 'comments',
            layout: 'main',
            parent: '/candidates',
            module: 'HRPAC_CANDIDATES'
          }
        }
      ]
    },
    {
      path: '/candidates/:id/compare',
      name: 'candidateCompare',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateCompareWrapper'),
      children: [
        {
          path: '/candidates/:id/compare/:dublicateId',
          name: 'candidateCompareId',
          meta: {
            auth: true,
            rightPanel: true,
            layout: 'main',
            parent: '/candidates',
            module: 'HRPAC_CANDIDATES'
          }
        }
      ]
    },
    {
      path: '/candidates/AttachmentPage/:id',
      name: 'candidatesAttachmentPageId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/candidates/AttachmentPage',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/AttachmentPage/AttachmentPage')
    },
    {
      path: '/vacancies/:id/AttachmentPage',
      name: 'candidatesAttachmentPage',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies/:id/AttachmentPage',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/AttachmentPage/MassAttachmentPage')
    },
    {
      path: '/notifications',
      name: 'Notifications',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/notifications',
        module: 'HRPAC_NOTIFICATIONS'
      },
      component: () => import('Parts/Notifications/View/Notifications')
    },
    {
      path: '/notificationsSetting',
      name: 'HRPAC_NOTIFICATIONS_SETTINGS',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/notifications',
        module: 'HRPAC_NOTIFICATIONS_SETTINGS'
      },
      component: () => import('Parts/Notifications/View/NotificationsSettings')
    },
    {
      path: '/vacancies/edit',
      name: 'vacanciesEdit',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/vacancies/mass_edit',
      name: 'vacanciesMassEdit',
      meta: {
        auth: true,
        changeableList: true,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/vacancies/edit/:id',
      name: 'vacanciesEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/vacancies/:id/duplicate',
      name: 'vacanciesDuplicate',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/vacancies/:id/comments/:commentId',
      name: 'commentIdVacancy',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/List/VacancyWrapper'),
      async beforeEnter(to, from, next) {
        const truphyId = await store.dispatch(
          'vacancy/getMetadata',
          to.params.id
        );
        if (truphyId) {
          next();
        } else {
          next('/vacancies');
        }
      }
    },

    {
      path: '/vacancies/:id/createTemplate',
      name: 'vacanciesTemplateId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY_TEMPLATE'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },

    {
      path: '/vacancies',
      name: 'HRPAC_VACANCY',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/List/VacancyWrapper'),
      children: [
        {
          path: '/vacancies/:id',
          name: 'vacancyId',
          meta: {
            auth: true,
            rightPanel: true,
            layout: 'main',
            parent: '/vacancies',
            module: 'HRPAC_VACANCY'
          },
          component: () => import('Parts/Vacancy/View/VacancyCardNew'),

          async beforeEnter(to, from, next) {
            await store.dispatch('vacancy/getMetadata', to.params.id);

            next();
          }
        }
      ]
    },
    {
      path: '/vacancies/AttachmentPage/:id',
      name: 'vacanciesAttachmentPageId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/vacancies/AttachmentPage',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/AttachmentPage/AttachmentPage')
    },
    {
      path: '/templates/edit',
      name: 'templateEdit',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        module: 'HRPAC_VACANCY_TEMPLATE',
        customUrl:
          '?module=HRPAC_VACANCY_TEMPLATE&action=getTemplateView&record='
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/templates/:id/edit',
      name: 'templateEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        module: 'HRPAC_VACANCY_TEMPLATE',
        customUrl:
          '?module=HRPAC_VACANCY_TEMPLATE&action=getTemplateView&record='
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/login',
      name: 'LoginPage',
      meta: { auth: false, layout: 'empty' },
      component: () => import('@/components/parts/Auth/LoginPage')
    },
    {
      path: '/greeting',
      name: 'Greeting',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main'
      },
      component: () => import('Parts/Greeting/GreetingPage')
    },
    {
      path: '/restore/:login/:id',
      name: 'RestorePasswordPage',
      meta: { auth: false, layout: 'empty' },
      component: () => import('Parts/Auth/RestorePasswordPage')
    },
    {
      path: '/oldpage/:url',
      props: true,
      name: '*',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        reload: true
      },
      component: () => import('Parts/OldPage/OldPage')
    },
    {
      path: '/coordination',
      name: 'HRPAC_COORDINATION',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/coordination',
        module: 'HRPAC_COORDINATION'
      },
      component: () => import('Parts/Coordination3.0/List/CoordinationWrapper')
    },
    {
      path: '/coordination/:id',
      name: 'coordinationsId',
      meta: {
        auth: true,
        rightPanel: true,
        layout: 'main',
        parent: '/coordination',
        module: 'HRPAC_COORDINATION'
      },
      children: [
        {
          path: '/coordination/:id/comments/:commentId',
          name: 'commentIdCoordination',
          meta: {
            auth: true,
            rightPanel: true,
            trigger: 'comments',
            layout: 'main',
            parent: '/coordination',
            module: 'HRPAC_COORDINATION'
          }
        }
      ],
      component: () =>
        import('Parts/Coordination3.0/List/CoordinationCardWrapper')
    },
    {
      path: '/coordination_request',
      name: 'HRPAC_COORDINATION_REQUESTS',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/coordination_request',
        module: 'HRPAC_COORDINATION_REQUESTS'
      },

      component: () =>
        import('Parts/Coordination3.0/List/CoordinationRequestWrapper')
    },
    {
      path: '/coordination_request/create',
      name: 'HRPAC_COORDINATION_REQUESTS_CREATE',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/coordination_request',
        module: 'HRPAC_COORDINATION_REQUESTS'
      },
      component: () =>
        import('Parts/Coordination3.0/Edit/CoordinationRequestEditWrapper.vue')
    },
    {
      path: '/coordination_request/edit/:id',
      name: 'HRPAC_COORDINATION_REQUESTS_EDIT',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/coordination_request',
        module: 'HRPAC_COORDINATION_REQUESTS'
      },
      component: () =>
        import('Parts/Coordination3.0/Edit/CoordinationRequestEditWrapper.vue')
    },
    {
      path: '/coordination_request/:id',
      name: 'HRPAC_COORDINATION_REQUESTS_CARD',
      meta: {
        auth: true,
        rightPanel: true,
        layout: 'main',
        parent: '/coordination_request',
        module: 'HRPAC_COORDINATION_REQUESTS'
      },
      children: [
        {
          path: '/coordination_request/:id/comments/:commentId',
          name: 'commentIdCoordinationRequest',
          meta: {
            auth: true,
            rightPanel: false,
            trigger: 'comments',
            layout: 'main',
            parent: '/coordination_request',
            module: 'HRPAC_COORDINATION_REQUESTS'
          }
        }
      ],
      component: () =>
        import('Parts/Coordination3.0/View/CoordinationRequestCardWrapper.vue')
    },
    {
      path: '/coordination_request/:id/duplicate',
      name: 'coordinationRequestDuplicate',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/coordination_request',
        module: 'HRPAC_COORDINATION_REQUESTS'
      },
      component: () =>
        import('Parts/Coordination3.0/Edit/CoordinationRequestEditWrapper.vue')
    },
    {
      path: '/coordination_plan',
      name: 'HRPAC_COORDINATION_PLANS',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '',
        module: 'HRPAC_COORDINATION_PLANS'
      },
      component: () =>
        import('Parts/Coordination3.0/Plan/View/CoordinationPlanCard.vue')
    },
    {
      path: '/coordination_plan/:id',
      name: 'HRPAC_COORDINATION_PLANS_ITEM',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/coordination_plan',
        module: 'HRPAC_COORDINATION_PLANS'
      },
      component: () =>
        import('Parts/Coordination3.0/Plan/View/CoordinationPlanCard.vue')
    },
    {
      path: '/coordination_plan/:id/edit',
      name: 'HRPAC_COORDINATION_PLANS_EDIT',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/coordination_plan',
        module: 'HRPAC_COORDINATION_PLANS'
      },
      component: () =>
        import('Parts/Coordination3.0/Plan/Edit/CoordinationPlanEdit.vue')
    },
    {
      path: '/users',
      name: 'Users',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users',
        module: 'Users'
      },
      component: () => import('Parts/Users/List/UsersWrapper')
    },
    {
      path: '/users/:id',
      name: 'UsersId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users',
        module: 'Users'
      },
      component: () => import('Parts/Users/View/UsersCard')
    },
    {
      path: '/users/:id/edit',
      name: 'usersEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id?/edit/general',
      name: 'usersFormEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/calendar',
      name: 'usersEditCalendar',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/mail',
      name: 'usersMailEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/messengers',
      name: 'usersMessangersEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/response',
      name: 'usersResponseEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/additionally',
      name: 'usersAdditionallyEditId',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/global_search',
      props: true,
      name: 'searchPage',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        reload: true
      },
      component: () => import('Parts/SearchPage_3.0/SearchPage')
    },
    {
      path: '/about',
      props: true,
      name: 'About',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main'
      },
      component: () => import('Parts/About/About')
    },
    {
      path: '/calendar',
      name: 'HRPAC_CALENDAR',
      meta: {
        auth: true,
        rightPanel: false,
        layout: 'main',
        parent: '/calendar',
        module: 'HRPAC_CALENDAR'
      },
      component: () => import('Parts/Calendar/CalendarWrapper'),
      children: [
        {
          path: '/calendar/:type/:id',
          name: 'calendarId',
          meta: {
            auth: true,
            rightPanel: false,
            layout: 'main',
            parent: '/calendar',
            module: 'HRPAC_CALENDAR'
          }
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const isAuth = JSON.parse(localStorage.getItem('auth'));
  const requireAuth = to.matched.some(record => record.meta.auth);

  if (requireAuth && !isAuth) {
    try {
      const response = await mixin.methods.sendFormRequestFromIntent({
        request: {
          url: '?entryPoint=check_session_auth'
        }
      });

      if (response.data?.status && response.data?.status === 'authenticated') {
        store.commit('auth/setAuth');
        next();
      } else {
        router.push(`/login?return={${window.location.pathname}}`);
      }
    } catch (error) {
      router.push(`/login?return={${window.location.pathname}}`);
    }
  } else if (!requireAuth && isAuth) {
    next('/');
  } else {
    next();
  }
});

export default router;
